/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../../apiClient'
import type {
  ListCalendarsQueryResponse,
  ListCalendarsPathParams,
} from '../../types/ListCalendars'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { listCalendars } from '../../clients/listCalendars'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const listCalendarsQueryKey = ({
  integration_id,
}: {
  integration_id: ListCalendarsPathParams['integration_id']
}) =>
  [
    {
      url: '/api/v1/calendar-integration/:integration_id/calendars/',
      params: { integration_id: integration_id },
    },
  ] as const

export type ListCalendarsQueryKey = ReturnType<typeof listCalendarsQueryKey>

export function listCalendarsQueryOptions(
  {
    integration_id,
  }: { integration_id: ListCalendarsPathParams['integration_id'] },
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const queryKey = listCalendarsQueryKey({ integration_id })
  return queryOptions<
    ListCalendarsQueryResponse,
    ResponseErrorConfig<Error>,
    ListCalendarsQueryResponse,
    typeof queryKey
  >({
    enabled: !!integration_id,
    queryKey,
    queryFn: async ({ signal }) => {
      return listCalendars(
        { integration_id: integration_id },
        { ...config, signal: config.signal ?? signal }
      )
    },
  })
}

/**
 * @description List all calendars for the given integration.
 * @summary List calendars for a calendar integration
 * {@link /api/v1/calendar-integration/:integration_id/calendars/}
 */
export function useListCalendars<
  TData = ListCalendarsQueryResponse,
  TQueryData = ListCalendarsQueryResponse,
  TQueryKey extends QueryKey = ListCalendarsQueryKey,
>(
  {
    integration_id,
  }: { integration_id: ListCalendarsPathParams['integration_id'] },
  options: {
    query?: Partial<
      QueryObserverOptions<
        ListCalendarsQueryResponse,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<RequestConfig> & { client?: Client }
  } = {}
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const queryKey =
    resolvedOptions?.queryKey ?? listCalendarsQueryKey({ integration_id })

  const query = useQuery(
    {
      ...listCalendarsQueryOptions({ integration_id }, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey
  }

  query.queryKey = queryKey as TQueryKey

  return query
}
